import { render, staticRenderFns } from "./DataMapBlocklets.vue?vue&type=template&id=0a2e5e62&"
import script from "./DataMapBlocklets.vue?vue&type=script&lang=js&"
export * from "./DataMapBlocklets.vue?vue&type=script&lang=js&"
import style0 from "./DataMapBlocklets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports